import { useState } from 'react';
import { supabase } from '../supabaseClient';
import './Settings.css';

function Settings() {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');

  const handlePasswordChange = async (e) => {
    e.preventDefault();
    setError(null);
    setSuccessMessage('');

    if (newPassword.length < 6) {
      setError('A nova senha deve ter no mínimo 6 caracteres.'); return;
    }
    if (newPassword !== confirmPassword) {
      setError('As senhas não coincidem.'); return;
    }

    setLoading(true);
    const { error: updateError } = await supabase.auth.updateUser({ password: newPassword });
    if (updateError) {
      setError(updateError.message);
    } else {
      setSuccessMessage('Senha alterada com sucesso! Você será deslogado em breve.');
      setNewPassword('');
      setConfirmPassword('');
    }
    setLoading(false);
  };

  return (
    <div className="settings-container">
      <div className="settings-header">
        <h2>Alterar Senha</h2>
        <p>Para sua segurança, escolha uma senha forte e não a compartilhe com ninguém.</p>
      </div>

      <div className="settings-content">
        <form onSubmit={handlePasswordChange} className="password-form">
          <div className="form-group">
            <label htmlFor="newPassword">Nova Senha</label>
            <input 
              id="newPassword" 
              type="password" 
              placeholder="••••••••"
              value={newPassword}
              onChange={(e) => setNewPassword(e.target.value)}
              required 
            />
          </div>
          <div className="form-group">
            <label htmlFor="confirmPassword">Confirmar Nova Senha</label>
            <input 
              id="confirmPassword" 
              type="password"
              placeholder="••••••••"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)} 
              required
            />
          </div>
          
         
          <div className="message-area">
            {error && <p className="error-message">{error}</p>}
            {successMessage && <p className="success-message">{successMessage}</p>}
          </div>

          <div className="form-actions">
            <button type="submit" className="save-button" disabled={loading}>
              {loading ? 'Salvando...' : 'Salvar Nova Senha'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default Settings;